const materialTweakingFragmentShader = `
    precision highp float;
    
    varying vec2 vPosition;
    varying vec2 vUV;
    
    // Our texture.
    uniform sampler2D u_image;
    uniform float B;
    uniform float C;
    uniform float H;
    uniform float S;
    uniform float Bcr;
    uniform float Bmg;
    uniform float Byb;
    float hue2rgb(float p, float q, float t_) {
        float t = t_;
        if (t < 0.0) t += 1.0;
        if (t > 1.0) t -= 1.0;
        if (t < 1.0/6.0) return p + (q - p) * 6.0 * t;
        if (t < 1.0/2.0) return q;
        if (t < 2.0/3.0) return p + (q - p) * (2.0/3.0 - t) * 6.0;
        return p;
    }
    vec3 hsl2rgb(vec3 hsl) {
        vec3 rgb;
        if (hsl.y == 0.0) {
            rgb = vec3(hsl.z); // achromatic
        } else {
            float q = hsl.z < 0.5 ? hsl.z * (1.0 + hsl.y) : hsl.z + hsl.y - hsl.z * hsl.y;
            float p = 2.0 * hsl.z - q;
            rgb.r = hue2rgb(p,q, hsl.x + 1.0/3.0);
            rgb.g = hue2rgb(p,q, hsl.x);
            rgb.b = hue2rgb(p,q, hsl.x - 1.0/3.0);
        }
        return rgb;
    }
    
    vec3 rgb2hsl(vec3 rgb) {
        float mx = max(max(rgb.r, rgb.g), rgb.b);
        float mn = min(min(rgb.r, rgb.g), rgb.b);
        vec3 hsl = vec3((mx+mn)/2.0);
        if (mx == mn) {
            // achromatic
            hsl.x = 0.0;
            hsl.y = 0.0;
        } else {
            float d = mx - mn;
            hsl.y = hsl.z > 0.5 ? d / (2.0 - mx - mn) : d / (mx + mn);
            if (mx == rgb.r) {
                hsl.x = (rgb.g-rgb.b) / d + (rgb.g < rgb.b ? 6.0: 0.0);
            } else if (mx == rgb.g) {
                hsl.x = (rgb.b - rgb.r) / d + 2.0;
            } else {
                hsl.x = (rgb.r - rgb.g) / d + 4.0;
            }
            hsl.x /= 6.0;
        }
        return hsl;
    }
    
    vec3 rgb2yuv(vec3 rgb) {
        vec3 yuv = vec3(0.0);
        yuv.x = rgb.r * 0.299000 + rgb.g * 0.587000 + rgb.b * 0.1140;
        yuv.y = rgb.r * -0.14713 + rgb.g * -0.28886 + rgb.b * 0.4360;
        yuv.z = rgb.r * 0.615000 + rgb.g * -0.51499 + rgb.b * -0.10001;
        return yuv;
    }
    
    vec3 yuv2rgb(vec3 yuv) {
        vec3 rgb;
        rgb.r = 1.00000 * yuv.x + 0.000000 * yuv.y + 1.13983 * yuv.z;
        rgb.g = 1.00000 * yuv.x + -0.39465 * yuv.y + -0.5806 * yuv.z;
        rgb.b = 1.00000 * yuv.x + 2.032110 * yuv.y + 0.00000 * yuv.z;
        return rgb;
    }
    
    vec4 tweakColor(vec4 I, float B, float C, float H, float S, float mu, float Bcr, float Bmg, float Byb) {
        vec3 hsl = rgb2hsl(I.rgb);
        hsl.x = mod(hsl.x + H + 1.0, 1.0);
        hsl.y = min(1.0, max(0.0, hsl.y + S));
        vec3 middle = hsl2rgb(hsl);
        vec3 yuv = rgb2yuv(middle);
        //mu coming from
        float f = pow(4.0, C);
        yuv.x = mu + f * (yuv.x - mu) + B;
        vec3 new_color = yuv2rgb(yuv);
        new_color = new_color + 0.25 * Bcr * vec3(1.0, -1.0, -1.0);
        new_color = new_color + 0.25 * Bmg * vec3(-1.0, 1.0, -1.0);
        new_color = new_color + 0.25 * Byb * vec3(-1.0, -1.0, 1.0);
        return vec4(clamp(new_color,0.0,1.0), I.a);
    }
    
    void main() {
        vec4 I = texture2D(u_image, vUV).rgba;
        float mu = rgb2yuv(texture2D(u_image, vUV, 100.0).rgb).x;
        gl_FragColor = tweakColor(I, B, C, H, S, mu, Bcr, Bmg, Byb);
    }
`;

export default materialTweakingFragmentShader;